module AccessEditor

open Dotyk.Portal.Model
open Fable.React
open Fable.React.Props
open Fulma
open Elmish
open Browser.Dom
open Browser.Types

type AccessProps = {
    url : string
}

type private State =
| Loading of string
| Error of string
| Working of AccessInfo*string

type private Msg =
| Loaded of AccessInfo
| Error of string
| AddAccess of UserAccess
| RemoveAccess of UserAccess

let private update msg model =
    console.log("update", msg, model)

    match msg with
    | Loaded a ->
        match model with
        | Loading (url) ->
            Working (a, url), Cmd.Empty
        | Working (_, url) ->
            Working (a, url), Cmd.Empty
        | State.Error _ -> model, Cmd.Empty

    | Error e -> State.Error e, Cmd.Empty
    | RemoveAccess a ->
        match model with
        | Working (_, url) ->
            model,
            Cmd.OfPromise.either
                (Service.removeAccess url)
                a
                (Loaded)
                (fun e -> e.ToString() |> Error)
        | _ -> model, Cmd.Empty
    | AddAccess a ->
        match model with
        | Working (_, url) ->
            model,
            Cmd.OfPromise.either
                (Service.addAccess url)
                a
                (Loaded)
                (fun e -> e.ToString() |> Error)
        | _ -> model, Cmd.Empty

let private view model dispatch =
    match model with
    | State.Error e -> str e
    | Loading _ -> Progress.progress [] []
    | Working (model, _) ->
        let item =
            if model.canEdit
            then
                fun i ->
                    td []
                       [ Button.button
                            [ Button.OnClick (fun e -> e.preventDefault(); i |> RemoveAccess |> dispatch )]
                            [ str "Remove" ] ]
            else fun _ -> nothing

        let onSubmit =
            fun (e:Event) ->
                e.preventDefault()
                let f = e.target :?> HTMLFormElement
                let name = (f.elements.namedItem("username") :?> HTMLInputElement).value
                let role = (f.elements.namedItem("role") :?> HTMLSelectElement).value
                { userName = name; role = role } |> AddAccess |> dispatch

        let editor =
            if model.canEdit
            then
                Card.card
                    []
                    [ Card.content [] [
                        form
                            [ OnSubmit (onSubmit) ]
                            [ Columns.columns [] [
                                  Column.column [] [ Input.input [ Input.Option.Props [ Props.Name "username" ] ] ]
                                  Column.column [ Column.Width(Screen.All, Column.IsNarrow) ] [ select [ Props.Name "role" ] (model.roles |> List.map (fun i -> option [ Props.Value i ] [ str i ])) ]
                                  Column.column [ Column.Width(Screen.All, Column.IsNarrow) ] [ Button.button [] [ str "Add" ] ]
                              ]
                            ]
                        ]
                    ]
            else nothing
        div
            []
            [   editor
                Table.table
                    [ Table.IsFullWidth ]
                    [ thead []
                        [ tr [] [
                            th [] [ str "User" ]
                            th [] [ str "Role" ]
                            th [] []
                        ] ]
                      tbody
                        []
                        (model.userAccesses |> List.map (fun i -> tr [] ([ td [] [ str i.userName ]; td [] [ str i.role ] ]@([item i]))))
                    ]
            ]

let private init (arg:AccessProps) =
    console.log("init", arg);
    (Loading arg.url),
    Cmd.OfPromise.either
        Service.getAccess
        arg.url
        (Loaded)
        (fun e ->
            console.log(e);
            e.ToString() |> Error)

let private fcomp =
    FunctionComponent.Of
        ((fun (props:AccessProps ) ->
            let model = Hooks.useState<State option>(None)
            let dispatch = Hooks.useState({| f = fun _ -> () |})
            let program = Hooks.useStateLazy(fun () ->
                let mutable lastState = model.current
                let mutable lastDispatch = dispatch.current.f

                let prog = 
                    Program.mkProgram
                        init
                        update
                        view
                    |> Program.withSetState (
                        fun m d ->
                            let newState = Some m

                            if not (newState.Equals(lastState)) then
                                lastState <- newState
                                model.update(newState)

                            if (not (LanguagePrimitives.PhysicalEquality lastDispatch d)) then
                                lastDispatch <- d
                                dispatch.update({| f = d |})
                        )
                prog |> Program.runWith props
                prog
            )

            match model.current with
            | None -> nothing
            | Some m -> (program.current |> Program.view) m dispatch.current.f
        ), ?withKey = Some (fun p -> p.url))


let accessEditor url =
    fcomp { url = url }
